// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.setting-container {
  display: flex;
  justify-content: space-between;
}

.setting-content-container {
  background-color: rgb(242, 240, 240);
  border-radius: 5px;
  padding: 10px;
  box-shadow: rgb(180, 179, 179);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.setting-content-container span {
  vertical-align: text-bottom;
}

.benefits-container > div:last-child {
  color: #1F1F1F;
}

.setting-wrapper {
  width: 90%;
  margin-top: 16px;
}

.setting-wrapper > div {
  margin-block-end: 0px !important;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./styless.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,8BAAA;AACJ;;AACA;EACI,oCAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAEJ;;AACA;EACI,2BAAA;AAEJ;;AAAA;EACI,cAAA;AAGJ;;AADA;EACI,UAAA;EACA,gBAAA;AAIJ;;AAFA;EACI,gCAAA;EACA,WAAA;AAKJ","sourcesContent":[".setting-container {\n  display: flex;\n  justify-content: space-between;\n}\n\n.setting-content-container {\n  background-color: rgb(242, 240, 240);\n  border-radius: 5px;\n  padding: 10px;\n  box-shadow: rgb(180, 179, 179);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.setting-content-container span {\n  vertical-align: text-bottom;\n}\n\n.benefits-container > div:last-child {\n  color: #1F1F1F;\n}\n\n.setting-wrapper {\n  width: 90%;\n  margin-top: 16px;\n}\n\n.setting-wrapper > div {\n  margin-block-end: 0px !important;\n  width: 100%;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
